(function ($, Drupal, once) {
  'use strict';

  Drupal.behaviors.searchExpand = {
    attach: function (context, settings) {
      once('searchExpand', '.search-icon', context).forEach(function (element) {
        element.addEventListener('click', function () {
          console.log('click');
          this.classList.toggle('search-box-expanded');
          const searchBox = document.querySelector('.search-box');
          if (searchBox.style.display === 'none' || searchBox.style.display === '') {
            searchBox.style.display = 'block';
          } else {
            searchBox.style.display = 'none';
          }
          document.querySelector('.search-box input').focus();
          document.querySelectorAll('.menu-item').forEach(function (menuItem) {
            menuItem.classList.remove('menu-dropdown-expanded');
          });

          if (document.querySelector('.search-icon').classList.contains('search-box-expanded')) {
            document.body.classList.add('search-dropdown-open');
            document.body.classList.add('menu--navigation-menu-open');
          } else {
            document.body.classList.remove('search-dropdown-open');
            document.body.classList.remove('menu--navigation-menu-open');
          }

          document.querySelector('.menu-close').classList.remove('menu-close-visible');
        });
      });
    },
  };
})(jQuery, Drupal, once);
